import { createActions, createReducer } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  createTenantRequest: ['listingId', 'data'],
  createTenantSuccess: ['tenant'],
  createTenantFailure: ['error'],
})

export const TenantTypes = Types
export const TenantActions = Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  creating: false,
  createSuccess: null,
  createError: null,
}

/* ------------- Reducers ------------- */
const createTenantRequest = (state) => ({
  ...state,
  creating: true,
  createSuccess: null,
  createError: null,
})

const createTenantSuccess = (state, action) => ({
  ...state,
  creating: false,
  createSuccess: action.tenant,
  createError: null,
})

const createTenantFailure = (state, action) => ({
  ...state,
  creating: false,
  createSuccess: null,
  createError: action.error,
})

/* ------------- Hook Types to Reducers ------------- */
export default createReducer(INITIAL_STATE, {
  [Types.CREATE_TENANT_REQUEST]: createTenantRequest,
  [Types.CREATE_TENANT_SUCCESS]: createTenantSuccess,
  [Types.CREATE_TENANT_FAILURE]: createTenantFailure,
})